webpackJsonp([12],{

/***/ 769:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/api/service.js
var service = __webpack_require__(91);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/service/Actions.vue



/* harmony default export */ var Actions = ({
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      snackbar: false
    };
  },

  computed: {
    url: function url() {
      return service["a" /* default */].isOfferType(this.service.service_type) ? this.service.url : this.service.url.replace('/o/', '/p/');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06182378","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/Actions.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.url),expression:"url",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(function () { return _vm.snackbar = true; }),expression:"() => snackbar = true",arg:"success"}],attrs:{"icon":""}},[_c('v-icon',[_vm._v("link")])],1),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.url))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$can('update', 'services'))?_c('v-btn',{staticClass:"ml-2",attrs:{"router":"","href":{ name: 'Service', params: { id: _vm.service.id } },"primary":"","light":""}},[_vm._v("\n    "+_vm._s(_vm.$t('service.actions.edit'))+"\n  ")]):_vm._e(),_vm._v(" "),_c('v-snackbar',{model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.$t('service.actions.copy'))+"\n    "),_c('v-btn',{attrs:{"icon":"","light":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var service_Actions = (esExports);
// CONCATENATED MODULE: ./src/components/service/Actions.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Actions,
  service_Actions,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_service_Actions = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/api/service.js
var service = __webpack_require__(91);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/service/Header.vue




/* harmony default export */ var Header = ({
  components: {
    Price: formatters["d" /* Price */]
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    scope: {
      type: String,
      default: 'public'
    }
  },
  computed: {
    isOffer: function isOffer() {
      return service["a" /* default */].isOfferScope(this.scope);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a407cb5c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/Header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',[_vm._v("\n  "+_vm._s(_vm.service.title)+"\n  "),_c('v-spacer'),_vm._v(" "),(_vm.isOffer)?_c('price',{attrs:{"value":_vm.service.price}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var service_Header = (esExports);
// CONCATENATED MODULE: ./src/components/service/Header.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Header,
  service_Header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_service_Header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__(31);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/service/Meta.vue



/* harmony default export */ var Meta = ({
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  computed: {
    options: function options() {
      var _this = this;

      return keys_default()(this.service.service_options).filter(function (key) {
        return _this.service.service_options[key];
      }).filter(function (key) {
        return key !== 'message';
      }).map(function (key) {
        return _this.processOption(key);
      });
    }
  },
  methods: {
    processOption: function processOption(key) {
      var value = this.service.service_options[key];
      if (key === 'response_delay') {
        return {
          key: value.split('.')[1],
          value: value.split('.')[0]
        };
      }
      if (key === 'service_type') {
        return {
          key: key,
          value: this.$t('service.meta.services.' + value)
        };
      }
      return {
        key: key,
        value: value
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eac2f68","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/Meta.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('v-chip',{staticClass:"primary primary--text",attrs:{"outline":"","small":""}},[_vm._v(_vm._s(_vm.$t(("service.meta." + (_vm.service.service_type)))))]),_vm._v(" "),_vm._l((_vm.options),function(option){return _c('v-chip',{key:option.key,staticClass:"secondary secondary--text",attrs:{"outline":"","small":""}},[_vm._v("\n    "+_vm._s(_vm.$t(("service.meta.options." + (option.key)), { value: option.value }))+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var service_Meta = (esExports);
// CONCATENATED MODULE: ./src/components/service/Meta.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Meta,
  service_Meta,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_service_Meta = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/service/Content.vue


/* harmony default export */ var Content = ({
  props: {
    service: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5d81176","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/Content.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.service.description.short)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var service_Content = (esExports);
// CONCATENATED MODULE: ./src/components/service/Content.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Content,
  service_Content,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_service_Content = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/api/service.js
var service = __webpack_require__(91);

// EXTERNAL MODULE: ./src/components/service/Header.vue + 2 modules
var Header = __webpack_require__(770);

// EXTERNAL MODULE: ./src/components/service/Meta.vue + 2 modules
var Meta = __webpack_require__(771);

// EXTERNAL MODULE: ./src/components/service/Content.vue + 2 modules
var Content = __webpack_require__(772);

// EXTERNAL MODULE: ./src/components/service/Actions.vue + 2 modules
var Actions = __webpack_require__(769);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/service/Card.vue







/* harmony default export */ var Card = ({
  components: {
    ServiceHeader: Header["a" /* default */],
    ServiceMeta: Meta["a" /* default */],
    ServiceContent: Content["a" /* default */],
    ServiceActions: Actions["a" /* default */]
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    scope: {
      type: String,
      required: true
    }
  },
  computed: {
    isOffer: function isOffer() {
      return service["a" /* default */].isOfferScope(this.scope);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c184f95","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/Card.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('service-header',{attrs:{"service":_vm.service,"scope":_vm.scope}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.isOffer)?[_c('service-meta',{attrs:{"service":_vm.service}}),_vm._v(" "),_c('service-content',{attrs:{"service":_vm.service}}),_vm._v(" "),_c('v-divider')]:_vm._e(),_vm._v(" "),_c('service-actions',{attrs:{"service":_vm.service}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var service_Card = (esExports);
// CONCATENATED MODULE: ./src/components/service/Card.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Card,
  service_Card,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_service_Card = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 848:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/service/Actions.vue + 2 modules
var Actions = __webpack_require__(769);

// EXTERNAL MODULE: ./src/components/service/Card.vue + 2 modules
var Card = __webpack_require__(774);

// EXTERNAL MODULE: ./src/components/service/Content.vue + 2 modules
var Content = __webpack_require__(772);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(40);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/api/service.js
var service = __webpack_require__(91);

// EXTERNAL MODULE: ./src/components/messenger/previews/Offer.vue + 2 modules
var Offer = __webpack_require__(116);

// EXTERNAL MODULE: ./src/components/inputs/index.js + 75 modules
var components_inputs = __webpack_require__(170);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/service/Form.vue








/* harmony default export */ var Form = ({
  components: {
    OfferPreview: Offer["a" /* default */]
  },
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var serviceOptions = this.service.service_options || {};
    return {
      error: {},
      form: {
        serviceType: this.service.service_type,
        title: this.service.title,
        price: this.service.price,
        'service--serviceType': serviceOptions.service_type,
        'service--responseDelay': serviceOptions.response_delay,
        'prepaidMinute--minutes': serviceOptions.minutes,
        'mail--responseDelay': serviceOptions.response_delay,
        'mail--wordCount': serviceOptions.word_count,
        'product--message': serviceOptions.message,
        'availability--duration': serviceOptions.duration,
        'availability--availabilityType': serviceOptions.availability_type,
        experts: this.service.admin_ids || [],
        description: (this.service.description || {}).full || '',
        subtitle: this.service.subtitle,
        picture: (this.service.picture || {}).normal,
        shortDescription: (this.service.description || {}).short,
        keywords: (this.service.keywords || []).join(', '),
        expire: this.service.expire_at,
        portfolio: this.service.portfolio || [],
        maxUserPurchase: this.service.max_user_purchase,
        offerType: this.service.promotion ? 'promotion' : this.service.is_public !== false ? 'public' : 'private'
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'skiliko/services/isLoading'
  }), {
    isOffer: function isOffer() {
      return !this.service.id || service["a" /* default */].isOfferType(this.service.service_type);
    },
    typeServiceInputs: function typeServiceInputs() {
      return this.service.id ? [] : [{ key: 'serviceType', required: true, component: components_inputs["r" /* ServiceTypeInput */] }];
    },
    servicesInputs: function servicesInputs() {
      var _this = this;

      var prepaidMinuteValidations = [function (minutes) {
        if (_this.form.price / 50 < minutes) {
          return _this.$t('service.form.errors.minutes', { price: 50 });
        }
      }];

      return {
        service: [{ key: 'service--serviceType', required: true, component: components_inputs["s" /* ServicesInput */] }, { key: 'service--responseDelay', component: components_inputs["g" /* DelayInput */] }],
        prepaid_minute: [{ key: 'prepaidMinute--minutes', required: true, component: components_inputs["k" /* MinuteInput */], errors: prepaidMinuteValidations }],
        product: [{ key: 'product--message', required: true, component: components_inputs["q" /* RichTextInput */] }],
        mail: [{ key: 'mail--responseDelay', component: components_inputs["g" /* DelayInput */] }, { key: 'mail--wordCount', component: components_inputs["t" /* TextInput */], type: 'number' }],
        availability: [{ key: 'availability--availabilityType', required: true, component: components_inputs["b" /* AvailabilityTypeInput */] }, { key: 'availability--duration', required: true, component: components_inputs["k" /* MinuteInput */] }]
      }[this.form.serviceType] || [];
    },
    advancedInputs: function advancedInputs() {
      var _this2 = this;

      return [{ key: 'picture', component: components_inputs["i" /* FileInput */] }, { key: 'subtitle', component: components_inputs["t" /* TextInput */] }, { key: 'shortDescription', component: components_inputs["t" /* TextInput */], multiLine: true, counter: true, max: 150 }, { key: 'keywords', component: components_inputs["t" /* TextInput */] }, this.isOffer ? { key: 'expire', component: components_inputs["f" /* DateInput */] } : null, this.isOffer ? { key: 'maxUserPurchase', component: components_inputs["t" /* TextInput */], type: 'number', disabled: this.service.id } : null].filter(function (e) {
        return e;
      }).map(function (input) {
        return extends_default()({}, input, {
          label: _this2.$t('service.form.labels.' + input.key),
          errors: (_this2.error[input.key] || []).map(function (e) {
            return function () {
              return e;
            };
          })
        });
      });
    },
    offerInputs: function offerInputs() {
      return [].concat(toConsumableArray_default()(this.typeServiceInputs), [{ key: 'title', required: true, component: components_inputs["t" /* TextInput */] }, { key: 'price', required: true, component: components_inputs["p" /* PriceInput */] }], toConsumableArray_default()(this.servicesInputs), [{ key: 'offerType', required: true, component: components_inputs["m" /* OfferTypeInput */] }, { key: 'description', required: true, component: components_inputs["q" /* RichTextInput */] }, { key: 'portfolio', component: components_inputs["o" /* PortfolioInput */] }, this.$can('assign', 'services') ? { key: 'experts', component: components_inputs["h" /* ExpertsInput */] } : null]);
    },
    pageInputs: function pageInputs() {
      return [{ key: 'title', required: true, component: components_inputs["t" /* TextInput */] }, { key: 'description', required: true, component: components_inputs["q" /* RichTextInput */], autoGrow: true, multiLine: true }, { key: 'portfolio', component: components_inputs["o" /* PortfolioInput */] }];
    },
    inputs: function inputs() {
      var _this3 = this;

      return (this.isOffer ? this.offerInputs : this.pageInputs).filter(function (e) {
        return e;
      }).map(function (input) {
        return extends_default()({}, input, {
          label: _this3.$t('service.form.labels.' + input.key),
          errors: [].concat(toConsumableArray_default()(input.errors || []), toConsumableArray_default()((_this3.error[input.key] || []).map(function (e) {
            return function () {
              return e;
            };
          })))
        });
      });
    },
    offerData: function offerData() {
      var serviceOptions = {
        prepaid_minute: {
          minutes: this.form['prepaidMinute--minutes']
        },
        product: {
          message: this.form['product--message']
        },
        mail: {
          response_delay: this.form['mail--responseDelay'],
          word_count: this.form['mail--wordCount']
        },
        service: {
          service_type: this.form['service--serviceType'],
          response_delay: this.form['service--responseDelay']
        },
        availability: {
          duration: this.form['availability--duration'],
          availability_type: this.form['availability--availabilityType']
        }
      }[this.form.serviceType] || this.service.service_options;

      return {
        title: this.form.title,
        subtitle: this.form.subtitle,
        keywords: this.form.keywords,
        description: {
          full: this.form.description,
          short: this.form.shortDescription
        },
        picture: {
          normal: this.form.picture
        },
        admin_ids: this.form.experts,
        price: this.form.price,
        service_type: this.form.serviceType,
        service_options: serviceOptions,
        expire_at: this.form.expire,
        promotion: this.form.offerType === 'promotion',
        is_public: this.form.offerType !== 'private',
        portfolio: this.form.portfolio,
        max_user_purchase: this.form.maxUserPurchase
      };
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    update: 'skiliko/services/update',
    create: 'skiliko/services/create',
    remove: 'skiliko/services/remove'
  }), {
    submit: function submit() {
      var _this4 = this;

      if (this.service.id) {
        this.update({ id: this.service.id, data: this.offerData });
      } else {
        this.create({ data: this.offerData }).then(function (service) {
          _this4.$router.push({ name: 'Service', params: { id: service.id } });
        });
      }
    },
    deleteService: function deleteService() {
      var _this5 = this;

      if (confirm(this.$t('service.form.confirmDeletion'))) {
        this.remove({ id: this.service.id }).then(function (_) {
          return _this5.$router.push({ path: '/' });
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07b984a7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/Form.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_vm._l((_vm.inputs),function(input){return _c(input.component,{key:input.key,tag:"component",attrs:{"config":input},model:{value:(_vm.form[input.key]),callback:function ($$v) {_vm.$set(_vm.form, input.key, $$v)},expression:"form[input.key]"}})}),_vm._v(" "),(_vm.form.picture)?_c('v-card',{staticStyle:{"width":"200px"},attrs:{"img":_vm.form.picture,"height":"200px"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.advancedInputs),function(input){return _c(input.component,{key:input.key,tag:"component",attrs:{"config":input},model:{value:(_vm.form[input.key]),callback:function ($$v) {_vm.$set(_vm.form, input.key, $$v)},expression:"form[input.key]"}})}),_vm._v(" "),_c('offer-preview',{attrs:{"value":_vm.offerData}}),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[(_vm.service.id)?_c('v-btn',{staticClass:"mr-3",attrs:{"error":"","light":"","flat":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.deleteService()}}},[_vm._v("\n      "+_vm._s(_vm.$t('service.form.delete'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","primary":"","light":"","ripple":"","loading":_vm.loading}},[_vm._v("\n      "+_vm._s(_vm.$t('service.form.save'))+"\n    ")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var service_Form = (esExports);
// CONCATENATED MODULE: ./src/components/service/Form.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Form,
  service_Form,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_service_Form = (Component.exports);

// EXTERNAL MODULE: ./src/components/service/Header.vue + 2 modules
var Header = __webpack_require__(770);

// EXTERNAL MODULE: ./src/components/service/Meta.vue + 2 modules
var Meta = __webpack_require__(771);

// CONCATENATED MODULE: ./src/components/service/index.js
/* unused concated harmony import ServiceActions */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Actions["a" /* default */]; });
/* unused concated harmony import ServiceCard */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Card["a" /* default */]; });
/* unused concated harmony import ServiceContent */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Content["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return components_service_Form; });
/* unused concated harmony import ServiceHeader */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Header["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return Meta["a" /* default */]; });









/***/ }),

/***/ 991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/service/index.js + 3 modules
var service = __webpack_require__(848);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ServiceEdition.vue





/* harmony default export */ var ServiceEdition = ({
  components: {
    ServiceForm: service["a" /* ServiceForm */]
  },
  props: {
    id: Number,
    required: true
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    services: 'skiliko/services/collection'
  }), {
    service: function service() {
      return this.services[this.id];
    }
  }),
  methods: Object(vuex_esm["b" /* mapActions */])({
    fetch: 'skiliko/services/fetch'
  }),
  mounted: function mounted() {
    this.fetch({ id: this.id });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196e789c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ServiceEdition.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.service)?[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('pages.serviceedition.title', _vm.service)))]),_vm._v(" "),_c('v-card-text',[_c('service-form',{attrs:{"service":_vm.service}})],1)]:_c('v-progress-linear',{attrs:{"indeterminate":true,"height":"2"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_ServiceEdition = (esExports);
// CONCATENATED MODULE: ./src/pages/ServiceEdition.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ServiceEdition,
  pages_ServiceEdition,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_ServiceEdition = __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/12.e85d08cdacd91e1c3292.js